import { render, staticRenderFns } from "./AddReward.vue?vue&type=template&id=fc2b11b2&"
import script from "./AddReward.vue?vue&type=script&lang=ts&"
export * from "./AddReward.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports